
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"m15 2.278-9.434 9.24m5.042-1.09L15 14.723m-9.434-9.24L8.647 8.5M6.265 3.833c0 1.289-1.067 2.334-2.383 2.334-1.315 0-2.382-1.045-2.382-2.334C1.5 2.545 2.567 1.5 3.882 1.5s2.383 1.045 2.383 2.333m0 9.334c0 1.288-1.067 2.333-2.383 2.333-1.315 0-2.382-1.045-2.382-2.333s1.067-2.334 2.382-2.334 2.383 1.045 2.383 2.334"}})])
          )
        }
      }
    